var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var NoticeController = {
    /*****************************************************************************************************
        * Is using route "api/notice" and http method "GET" to call the back-end.
    
        * @returns {NoticeDownloadDto[]}
    ******************************************************************************************************/
    Get: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/notice", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/notice" and http method "POST" to call the back-end.
    
        * @param {File} mediaData
        * @param {File} mediaHandWritings
        * @param {NoticeUploadDto} dto
        * @returns {NoticeDownloadDto}
    ******************************************************************************************************/
    Post: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaData)
            fd.append("mediaData", data.mediaData);
        if (data.mediaHandWritings)
            fd.append("mediaHandWritings", data.mediaHandWritings);
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/notice", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/notice/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} mediaData
        * @param {File} mediaHandWritings
        * @param {NoticeUploadDto} dto
        * @returns {NoticeDownloadDto}
    ******************************************************************************************************/
    Patch: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaData)
            fd.append("mediaData", data.mediaData);
        if (data.mediaHandWritings)
            fd.append("mediaHandWritings", data.mediaHandWritings);
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/notice/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=NoticeController.js.map